import './styles.scss';

import { ComponentProps, ReactNode } from 'react';

import { Card } from 'react-bootstrap';
import CardBubble from '@/features/DriveTimeTool/components/CardBubble';
import Tippy from '@tippyjs/react';
import { getClasses } from '@/utils';

export type CardHeaderProps = ComponentProps<typeof Card.Header> & {
  tooltip?: ReactNode;
  icon?: string;
  subtitle?: string;
  info?: string | JSX.Element;
  bubble?: string;
  children?: ReactNode;
  right?: string | JSX.Element;
};

const CardHeader = ({ tooltip, icon, subtitle, info, children, bubble, right, ...cardHeaderProps }: CardHeaderProps): JSX.Element => {
  return (
    <>
      {bubble && <CardBubble>{bubble}</CardBubble>}
      <Card.Header {...cardHeaderProps} className={getClasses('CardHeader', cardHeaderProps.className)}>
        {icon && (
          <div className="card-icon">
            <i className={icon} />
          </div>
        )}
        {(children || subtitle || tooltip) && (
          <div className="card-title">
            <div className="card-title-left">
              <div className="card-name">
                {children && <span>{children}</span>}
                {tooltip && (
                  <span className="card-help">
                    <Tippy content={tooltip} placement="right" className="tippy-dark">
                      <i className="sv sv-notification-circle" />
                    </Tippy>
                  </span>
                )}
              </div>
              {subtitle && <small className="card-info">{subtitle}</small>}
            </div>
            <div className="card-title-right">{right}</div>
          </div>
        )}
      </Card.Header>
    </>
  );
};

export default CardHeader;
